

import XDataTable from "./XDataTable.vue";
import SearchInput from "./SearchInput.vue";
import DataFilters from "../../utils/DataFilters";
import Helper from "../../utils/Helper";
import SearchDate from "./SearchDate.vue"
import XModal from "./XModal.vue";
import SearchSelect from "./SearchSelect.vue"
import {PropType} from "vue";
import GlobalEventBus, {EventsList} from "../../utils/GlobalEventBus";
import Column from "primevue/column";
import DataTable from "primevue/datatable";

export type transformDataType = 'bytesToHumanPresent' | 'trim'
export interface transformDataOptions {
  length?: 100,
}

export interface tableColumn {

  type: 'text' | 'select' | 'dateRange'
  label: string
  column: string
  style?: string
  options?: {
    showTime?: boolean
    showTimePassedFrom?: number
    items?: Array<{
      title: string
      value: string
    }>,
    showTextInsteadOfControlInHeader?: boolean,
    transformData?: transformDataType,
    transformDataOptions?: transformDataOptions,

  }

}

export default {
  name: "TablePage",
  components: {SearchInput, XDataTable, SearchDate, SearchSelect, Column, DataTable, XModal},
  mixins: [Helper, DataFilters],
  emits: ['tableItemsClick', 'beforeUpdate', 'afterUpdate', 'rowReorder'],
  props: {
    mainUrl: null,
    passFilterToUrl: {
      type: Boolean,
      default: true,
    },
    preserveLoadTableItemsOnCreate: Boolean,
    columns: {type: Array as PropType<tableColumn[]>},
    defaultSortColumn: null,
    defaultSortOrder: {
      type: [Number, String],
      default: 1
    },
    autoReloadTimer: {
      type: [null, Number],
      default: null,
    }
  },
  data() {
    return {

      isActive: true,

      tableLoading: true,
      timers: {
        tableItems: null,
        filterDebounce: null,
      },

      tableItems: null,

      nowSelectedReport: null,

      reportAddViewLoading: false,

      loadingElement: null,

      filters: {},
      totalRowsCount: 0,
      paginator: {
        page: 1,
        limit: 20,
      },

      custom_filters: null,

      reloadTimer: null,
      colsVisibilityTitles: null,
      colsVisibilityValues: null,

    }
  },
  methods: {

    hideShowCols() {

      if (!this.colsVisibilityValues)
        return;

      this.colsVisibilityValues?.forEach((item, index) => {

        const th = this.$refs.Table.$el.querySelector('th:nth-child(' + (index + 1) + ')')
        if (th)
          th.style.display = item ? '' : 'none';

        const tds = this.$refs.Table.$el.querySelectorAll('tr>td:nth-child(' + (index + 1) + ')')
        if (tds) {
          tds.forEach(i => i.style.display = item ? '' : 'none')
        }

      });

    },

    getCurrentUrlPathHash() {

      const md5 = function (d) {
        var r = M(V(Y(X(d), 8 * d.length)));
        return r.toLowerCase()
      };

      function M(d) {
        for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++) _ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _);
        return f
      }

      function X(d) {
        for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++) _[m] = 0;
        for (m = 0; m < 8 * d.length; m += 8) _[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32;
        return _
      }

      function V(d) {
        for (var _ = "", m = 0; m < 32 * d.length; m += 8) _ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255);
        return _
      }

      function Y(d, _) {
        d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _;
        for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) {
          var h = m, t = f, g = r, e = i;
          f = md5_ii(f = md5_ii(f = md5_ii(f = md5_ii(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_ff(f = md5_ff(f = md5_ff(f = md5_ff(f, r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = safe_add(m, h), f = safe_add(f, t), r = safe_add(r, g), i = safe_add(i, e)
        }
        return Array(m, f, r, i)
      }

      function md5_cmn(d, _, m, f, r, i) {
        return safe_add(bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r), m)
      }

      function md5_ff(d, _, m, f, r, i, n) {
        return md5_cmn(_ & m | ~_ & f, d, _, r, i, n)
      }

      function md5_gg(d, _, m, f, r, i, n) {
        return md5_cmn(_ & f | m & ~f, d, _, r, i, n)
      }

      function md5_hh(d, _, m, f, r, i, n) {
        return md5_cmn(_ ^ m ^ f, d, _, r, i, n)
      }

      function md5_ii(d, _, m, f, r, i, n) {
        return md5_cmn(m ^ (_ | ~f), d, _, r, i, n)
      }

      function safe_add(d, _) {
        var m = (65535 & d) + (65535 & _);
        return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m
      }

      function bit_rol(d, _) {
        return d << _ | d >>> 32 - _
      }

      let index = 0

      document.body.querySelectorAll('.tablePage').forEach((item, key) => {
        if (item === this.$refs.XDataTable.$el)
          index = key
      });

      return md5(this.mainUrl + this.$route.path + index)

    },

    async saveTableSettings() {

      this.$refs.XModal.hide()
      await this.getTableRows(true)
      this.hideShowCols()
      this.paginator.page = 1
      localStorage.setItem('table_settings_' + this.getCurrentUrlPathHash(), JSON.stringify({
        cols_visible: this.colsVisibilityValues,
        parginator_limit: this.paginator.limit
      }))

    },

    showColsModal() {

      this.colsVisibilityTitles = []

      if (!this.colsVisibilityValues)
        this.colsVisibilityValues = []

      this.$refs.Table.$el.querySelectorAll('.p-column-header-content').forEach((item, index) => {

        this.colsVisibilityTitles.push(item.textContent.replace('p-emptylabel', ''))

        const row = item.closest('[role="row"]')
        const th = row.querySelector('th:nth-child(' + (index + 1) + ')')

        this.colsVisibilityValues[index] = th.style.display !== 'none';

      })

      this.$refs.XModal.show();

    },
    sort(): void {
      this.getTableRows(true);
    },

    async tableItemsClick($event: any): Promise<void> {

      this.$emit('tableItemsClick', $event);

    },

    /*async onTextEnterKeyDown($column) {

        if (this.filters?.[$column] === '')
            delete this.filters[$column];

        await this.getTableRows(true);

    },*/

    async getTableRows($changeStateToLoading, onlyIfActive: boolean = false) {

      if (!onlyIfActive)
        if (!this.isActive)
          return;

      clearTimeout(this.reloadTimer);

      this.$emit('beforeUpdate');

      clearTimeout(this.timers.tableItems);
      if (!this.isActive) {

        if (this.autoReloadTimer)
          this.reloadTimer = setTimeout(this.getTableRows, this.autoReloadTimer);

        return null;
      }

      if ($changeStateToLoading)
        this.tableLoading = true;

      let n_filter = {}
      if (this.passFilterToUrl) {

        Object.entries(this.$route.query).forEach(item => {
          if (item[0].indexOf('tf_') === 0) {
            const filter_name = item[0].slice(3)
            n_filter[filter_name] = item[1]
          }
        });

      }
      n_filter = {...this.filters, ...n_filter, ...this.custom_filters}

      return await this.$xapi.post(
        this.mainUrl,
        {
          action: 'gettableItems',
          filter: n_filter,
          paginator: this.paginator,
          sort: {[this.$refs.Table?.d_sortField]: this.$refs.Table?.d_sortOrder}
        })
        .then(async (response) => {
          this.tableItems = response.data.tableItems;
          this.totalRowsCount = response.data.rows_count;
          //this.timers.tableItems = setTimeout(this.getTableRows, 10000);
          await this.$nextTick()
          this.hideShowCols()
          return this.tableItems;
        })
        .finally(() => {

          this.tableLoading = false;
          this.$emit('afterUpdate');

          if (this.autoReloadTimer)
            this.reloadTimer = setTimeout(this.getTableRows, this.autoReloadTimer);

        });


    },

    setCustomFilters($filters) {
      this.custom_filters = $filters;
    },

    getDateTimeString(time?: number, showTimePassedFrom?: number) {

      if (!time)
        return null;

      if (showTimePassedFrom) {
        return this.unixTimeStampToDateTime(time) + ' (' + this.secondsToDateTime(showTimePassedFrom - time) + ' назад)'
      } else {
        return this.unixTimeStampToDateTime(time)
      }

    },

    objectsEqual(object1, object2) {
      const keys1 = Object.keys(object1);
      const keys2 = Object.keys(object2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (let key of keys1) {
        if (object1[key] !== object2[key]) {
          return false;
        }
      }

      return true;
    },
    getTableItemsIfRouteQueryNotEqualsFilters(forceUpdate = false, dontSetFilters = false) {

      let q_filters = {}
      for (let item in this.$route.query) {
        if (item.indexOf('tf_') === 0) {
          q_filters[item.slice(3)] = this.$route.query[item]
        }
      }

      if (!this.passFilterToUrl) {
        dontSetFilters = true
      }

      if (forceUpdate || !this.objectsEqual(q_filters, this.filters)) {

        if (!dontSetFilters) {
          this.filters = q_filters;
          this.paginator.page = 1
        }

        this.getTableRows(true, true)
      }

    }


  },
  computed: {},
  mounted() {

    let fromStorage = localStorage.getItem('table_settings_' + this.getCurrentUrlPathHash())

    if (fromStorage) {
      fromStorage = JSON.parse(fromStorage)
      this.colsVisibilityValues = (fromStorage as any)?.cols_visible
      this.paginator.limit = (fromStorage as any).parginator_limit
    }

    if (!this.preserveLoadTableItemsOnCreate) {

      if (this.defaultSortColumn) {
        this.$refs.Table.d_sortField = this.defaultSortColumn;
        this.$refs.Table.d_sortOrder = this.defaultSortOrder ? parseInt(this.defaultSortOrder) : 1;
      }

      this.getTableRows(true);

    }

    if (fromStorage) {
      this.hideShowCols()
    }

  },
  activated() {

    this.isActive = true;

    if (this.autoReloadTimer)
      this.getTableRows();

    GlobalEventBus.on(EventsList.ReloadActiveTablePage, ($changeStateToLoading) => {
      this.getTableRows($changeStateToLoading, true)
    }, true);

    this.getTableItemsIfRouteQueryNotEqualsFilters()

  },
  deactivated() {

    this.isActive = false;

    if (this.autoReloadTimer)
      clearTimeout(this.reloadTimer)

    GlobalEventBus.off(EventsList.ReloadActiveTablePage)

  },
  created() {


  },
  watch: {

    filters: {
      deep: true,
      immediate: true,
      async handler(new_filter_value) {

        clearTimeout(this.filterDebounce)
        this.filterDebounce = setTimeout(async () => {

          this.paginator.page = 1

          let new_query = {}
          for (let item in this.$route.query)
            if (item.indexOf('tf_') !== 0)
              new_query[item] = this.$route.query[item]

          for (let item in new_filter_value) {
            if (Array.isArray(new_filter_value[item])) {

              let tmp = ''
              if (new_filter_value[item][0] instanceof Date)
                tmp += DataFilters.methods.dateToDMY(new_filter_value[item][0])


              if (new_filter_value[item][1] instanceof Date)
                tmp += '-' + DataFilters.methods.dateToDMY(new_filter_value[item][1])

              new_query['tf_' + item] = tmp

            } else {
              new_query['tf_' + item] = new_filter_value[item]
            }

          }

          const filtersNotEquals = !this.objectsEqual(this.$route.query, new_query)

          if (this.passFilterToUrl && filtersNotEquals) {
            await this.$router.push({path: this.$route.path, query: new_query})
          }

          this.getTableItemsIfRouteQueryNotEqualsFilters(filtersNotEquals, true)

        }, 500);

      }
    },

    /*$route: {
        deep: true,
        immediate: true,
        async handler(new_route_value, o) {

            if (!this.isActive)
                return;

            this.getTableItemsIfRouteQueryNotEqualsFilters(true)
        }

    }*/

  },
}
